import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function FolderOpenIcon({ className, width = 18, height = 17 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-400', className)}
            width={width}
            height={height}
            viewBox='0 0 18 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.4555 16.1144H4.54463C2.1363 16.1144 2.0088 14.7898 1.90255 13.7203L1.61921 10.1715C1.55546 9.48442 1.7538 8.79734 2.19296 8.24484C2.71713 7.60734 3.46088 7.26025 4.2613 7.26025H13.7388C14.525 7.26025 15.2688 7.60734 15.7717 8.20942L15.8921 8.37234C16.2746 8.8965 16.4446 9.534 16.3809 10.1786L16.0975 13.7132C15.9913 14.7898 15.8638 16.1144 13.4555 16.1144ZM4.2613 8.32275C3.78671 8.32275 3.33338 8.53525 3.03588 8.90359L2.9863 8.95317C2.75963 9.24359 2.63921 9.65442 2.68171 10.0794L2.96505 13.6282C3.06421 14.6623 3.10671 15.0519 4.54463 15.0519H13.4555C14.9005 15.0519 14.9359 14.6623 15.035 13.6211L15.3184 10.0723C15.3609 9.65442 15.2405 9.2365 14.9642 8.91067L14.8934 8.82567C14.5746 8.49275 14.1709 8.32275 13.7317 8.32275H4.2613Z'
                fill='currentColor'
            />
            <path
                d='M15.0208 8.6559C14.7304 8.6559 14.4895 8.41507 14.4895 8.12465V6.85674C14.4895 4.7459 14.1212 4.37757 12.0104 4.37757H10.2041C9.40371 4.37757 9.12746 4.09424 8.82288 3.69049L7.90913 2.47924C7.59746 2.0684 7.52663 1.96924 6.88913 1.96924H5.98954C3.87871 1.96924 3.51038 2.33757 3.51038 4.4484V8.09632C3.51038 8.38674 3.26954 8.62757 2.97913 8.62757C2.68871 8.62757 2.44788 8.38674 2.44788 8.09632V4.4484C2.44788 1.73549 3.27663 0.906738 5.98954 0.906738H6.89621C7.98704 0.906738 8.32704 1.2609 8.76621 1.84174L9.67288 3.0459C9.86413 3.3009 9.87829 3.31507 10.2112 3.31507H12.0175C14.7304 3.31507 15.5591 4.14382 15.5591 6.85674V8.12465C15.552 8.41507 15.3112 8.6559 15.0208 8.6559Z'
                fill='currentColor'
            />
            <path
                d='M10.8204 12.5728H7.17957C6.88915 12.5728 6.64832 12.3319 6.64832 12.0415C6.64832 11.7511 6.88915 11.5103 7.17957 11.5103H10.8204C11.1108 11.5103 11.3516 11.7511 11.3516 12.0415C11.3516 12.3319 11.1179 12.5728 10.8204 12.5728Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default FolderOpenIcon;

